import { useCallback, useMemo } from "react";
import axios from "axios";
import getSignature, { getPublicHeaders } from "./getSignature";
import { BasicInfo } from "./../Config/BasicInfo";

/** GlobalMax user API base — CRA exposes REACT_APP_* at build time */
const baseURL =
  (process.env.REACT_APP_API_BASE_URL || "http://localhost:8001/user").replace(/\/$/, "");

const useAxiosHelper = () => {
  const AxiosGet = useCallback(async (endPoint, body) => {
    try {
      const headers = await getSignature();
      const response = await axios.get(`${baseURL}${endPoint}`, { headers });
      BasicInfo.isDebug && console.log(`${endPoint} = `, response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} = `, error);
      if (error?.response?.status === 401) {
        // toastFailed("Authorization token is missing. Please log in again.");
      }
      throw error;
    }
  }, []);

  /* Public endpoints (registration settings, verify-sponsor,
     verify-username, register) must NOT carry an Authorization header — a
     stale token from a previous session would otherwise be sent and can be
     rejected. getPublicHeaders signs the request without it. */
  const AxiosGetPublic = useCallback(async (endPoint) => {
    try {
      const headers = await getPublicHeaders();
      const response = await axios.get(`${baseURL}${endPoint}`, { headers });
      BasicInfo.isDebug && console.log(`${endPoint} (public) = `, response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} (public) = `, error);
      throw error;
    }
  }, []);

  const AxiosPostPublic = useCallback(async (endPoint, body) => {
    try {
      const headers = await getPublicHeaders();
      const response = await axios.post(`${baseURL}${endPoint}`, body, { headers });
      BasicInfo.isDebug && console.log(`${endPoint} (public) = `, response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} (public) = `, error);
      throw error;
    }
  }, []);

  const AxiosPost = useCallback(async (endPoint, body) => {
    try {
      const headers = await getSignature();
      const response = await axios.post(`${baseURL}${endPoint}`, body, {
        headers,
      });
      BasicInfo.isDebug && console.log("response", response);
      return response.data;
    } catch (error) {
      BasicInfo.isDebug && console.log(`${endPoint} = `, error);
      if (error?.response?.status === 401) {
        // toastFailed("Authorization token is missing. Please log in again.");
      }
      throw error;
    }
  }, []);

  return useMemo(
    () => ({ AxiosGet, AxiosPost, AxiosGetPublic, AxiosPostPublic, baseURL }),
    [AxiosGet, AxiosPost, AxiosGetPublic, AxiosPostPublic]
  );
};

export default useAxiosHelper;
